module.exports = __webpack_public_path__ + "static/2-424ce394840cd8349eaba470a4f1b5a5.gif";